module.exports = __webpack_public_path__ + "img/biohazard.cd8c8bb1.svg";